// Author Lin
// Date 2021-08-30 16:25:25

class SithMesInventoryShipment {
    constructor({
                    id = null,
                    shipmentNo = '',
                    proWbs = '',
                    customerSalesOrder = '',
                    receiptCompany = '',
                    receiptAddress = '',
                    specialRequirement = '',
                    receiptPerson = '',
                    receiptPhoneNum = '',
                    exportControlCode = '',
                    transportDirection = '',
                    transporter = '',
                    transportType = '',
                    licensePlate = '',
                    leaveFactoryDate = '',
                    applicant = '',
                    confirmer = '',
                    logisticsStatus = '',
                    shipmentPr = '',
                    ucrNo = '',
                    attachment = '',
                    remark = '',
                    attachmentList = ''
                }
                    = {}) {
        this.id = id;
        this.shipmentNo = shipmentNo;
        this.proWbs = proWbs;
        this.customerSalesOrder = customerSalesOrder;
        this.receiptCompany = receiptCompany;
        this.receiptAddress = receiptAddress;
        this.specialRequirement = specialRequirement;
        this.receiptPerson = receiptPerson;
        this.receiptPhoneNum = receiptPhoneNum;
        this.exportControlCode = exportControlCode;
        this.transportDirection = transportDirection;
        this.transporter = transporter;
        this.transportType = transportType;
        this.licensePlate = licensePlate;
        this.leaveFactoryDate = leaveFactoryDate;
        this.applicant = applicant;
        this.confirmer = confirmer;
        this.logisticsStatus = logisticsStatus;
        this.shipmentPr = shipmentPr;
        this.ucrNo = ucrNo;
        this.attachment = attachment;
        this.remark = remark;
        this.attachmentList = attachmentList;
    }
}

function newEntity() {
    return new SithMesInventoryShipment();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'shipmentNo',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.shipmentNo',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'proWbs',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.proWbs',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.projectCode',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'projectName',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.projectName',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'customerSalesOrder',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.customerSalesOrder',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'receiptCompany',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.receiptCompany',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'receiptAddress',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.receiptAddress',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'specialRequirement',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.specialRequirement',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'receiptPerson',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.receiptPerson',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'receiptPhoneNum',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.receiptPhoneNum',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'exportControlCode',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.exportControlCode',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'transportDirection',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.transportDirection',
            sortable: true,
            form: {
                type: 'select'
                , options: [
                    {value: '1', text: '内到外'},
                    {value: '2', text: '内到内'},
                    {value: '3', text: '外到内'},
                    {value: '4', text: '外到外'}
                ]
            }
        },
        {
            key: 'transporter',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.transporter',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'transportType',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.transportType',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'licensePlate',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.licensePlate',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'leaveFactoryDate',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.leaveFactoryDate',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'applicantName',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.applicantName',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'confirmerName',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.confirmerName',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'logisticsStatus',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.logisticsStatus',
            sortable: true,
            form: {
                type: 'select'
                , options: [
                    {value: '1', text: '已申请'},
                    {value: '2', text: '已核对接收'},
                    {value: '3', text: '待包装'},
                    {value: '4', text: '已退回'},
                    {value: '5', text: '已包装'},
                    {value: '6', text: '已盘点'},
                    {value: '7', text: '已拆箱'},
                    {value: '8', text: '已装车待发货'},
                    {value: '9', text: '已发货'}
                ]
            }
        },
        {
            key: 'shipmentPr',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.shipmentPr',
            sortable: true,
            form: {
                type: 'input'
            }
        },
        {
            key: 'ucrNo',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.ucrNo',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'attachmentList',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.attachmentList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.inventory.sithMesInventoryShipment.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea'
            }
        }
    ])
}

const filter = {
    idFilter: "",
    idListFilter: "",
    shipmentNoFilter: "",
    proWbsFilter: "",
    customerSalesOrderFilter: "",
    receiptCompanyFilter: "",
    receiptAddressFilter: "",
    specialRequirementFilter: "",
    receiptPersonFilter: "",
    receiptPhoneNumFilter: "",
    exportControlCodeFilter: "",
    transportDirectionFilter: "",
    transporterFilter: "",
    transportTypeFilter: "",
    licensePlateFilter: "",
    leaveFactoryDateRteFilter: "",
    leaveFactoryDateLteFilter: "",
    applicantFilter: "",
    confirmerFilter: "",
    logisticsStatusFilter: "",
    shipmentPrFilter: "",
    ucrNoFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'shipmentNoFilter',
        label: 'label.sith.inventory.sithMesInventoryShipment.filter.shipmentNo',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'proWbsFilter',
        label: 'label.sith.inventory.sithMesInventoryShipment.filter.proWbs',
        disabled: false,
        form: {
            type: 'entityModalSelect'
            , entity: 'sithMesPrdProjectInfo'
            , correspondingField: 'wbsNumber'
        }
    },
    {
        key: 'customerSalesOrderFilter',
        label: 'label.sith.inventory.sithMesInventoryShipment.filter.customerSalesOrder',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'receiptCompanyFilter',
        label: 'label.sith.inventory.sithMesInventoryShipment.filter.receiptCompany',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'receiptAddressFilter',
        label: 'label.sith.inventory.sithMesInventoryShipment.filter.receiptAddress',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'specialRequirementFilter',
        label: 'label.sith.inventory.sithMesInventoryShipment.filter.specialRequirement',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'receiptPersonFilter',
        label: 'label.sith.inventory.sithMesInventoryShipment.filter.receiptPerson',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'receiptPhoneNumFilter',
        label: 'label.sith.inventory.sithMesInventoryShipment.filter.receiptPhoneNum',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'exportControlCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryShipment.filter.exportControlCode',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'transportDirectionFilter',
        label: 'label.sith.inventory.sithMesInventoryShipment.filter.transportDirection',
        disabled: false,
        form: {
            type: 'select'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '内到外'},
                {value: '2', text: '内到内'},
                {value: '3', text: '外到内'},
                {value: '4', text: '外到外'}
            ]
        }
    },
    {
        key: 'transporterFilter',
        label: 'label.sith.inventory.sithMesInventoryShipment.filter.transporter',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'transportTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryShipment.filter.transportType',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'licensePlateFilter',
        label: 'label.sith.inventory.sithMesInventoryShipment.filter.licensePlate',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'leaveFactoryDateRteFilter',
        label: 'label.sith.inventory.sithMesInventoryShipment.filter.leaveFactoryDateRte',
        disabled: false,
        form: {
            type: 'datepicker'
        }
    },
    {
        key: 'leaveFactoryDateLteFilter',
        label: 'label.sith.inventory.sithMesInventoryShipment.filter.leaveFactoryDateLte',
        disabled: false,
        form: {
            type: 'datepicker'
        }
    },
    {
        key: 'applicantFilter',
        label: 'label.sith.inventory.sithMesInventoryShipment.filter.applicant',
        disabled: false,
        form: {
            type: 'entityModalSelect'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'confirmerFilter',
        label: 'label.sith.inventory.sithMesInventoryShipment.filter.confirmer',
        disabled: false,
        form: {
            type: 'entityModalSelect'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'logisticsStatusFilter',
        label: 'label.sith.inventory.sithMesInventoryShipment.filter.logisticsStatus',
        disabled: false,
        form: {
            type: 'inputNumber'
        }
    },
    {
        key: 'shipmentPrFilter',
        label: 'label.sith.inventory.sithMesInventoryShipment.filter.shipmentPr',
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'ucrNoFilter',
        label: 'label.sith.inventory.sithMesInventoryShipment.filter.ucrNo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'shipmentNo',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.shipmentNo',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'proWbs',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.proWbs',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect'
            , entity: 'sithMesPrdProjectInfo'
            , correspondingField: 'wbsNumber'
        }
    },
    {
        key: 'customerSalesOrder',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.customerSalesOrder',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'receiptCompany',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.receiptCompany',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'receiptAddress',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.receiptAddress',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'specialRequirement',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.specialRequirement',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'receiptPerson',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.receiptPerson',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'receiptPhoneNum',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.receiptPhoneNum',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'exportControlCode',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.exportControlCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'transportDirection',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.transportDirection',
        sortable: true,
        disabled: false,
        form: {
            type: 'select'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '内到外'},
                {value: '2', text: '内到内'},
                {value: '3', text: '外到内'},
                {value: '4', text: '外到外'}
            ]
        }
    },
    {
        key: 'transporter',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.transporter',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'transportType',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.transportType',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'licensePlate',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.licensePlate',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'leaveFactoryDate',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.leaveFactoryDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker'
        }
    },
    {
        key: 'applicant',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.applicant',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'confirmer',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.confirmer',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'logisticsStatus',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.logisticsStatus',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber'
        }
    },
    {
        key: 'shipmentPr',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.shipmentPr',
        sortable: true,
        disabled: false,
        form: {
            type: 'input'
        }
    },
    {
        key: 'ucrNo',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.ucrNo',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea'
        }
    },
    {
        key: 'attachmentList',
        label: 'label.sith.inventory.sithMesInventoryShipment.entity.attachment',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment'
            , correspondingField: 'attachment'
        }
    }
]

export {
    SithMesInventoryShipment, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
        